import { Step } from "react-shepherd";

export enum OnboardingCSSClass {
  preferences = "preferences",
  navigation = "navigation",
  insightList = "insightList",
  activateInsight = "activateInsight",
  gamePlanList = "gamePlanList",
  analytics = "analytics",
  needsYourAttention = "needsYourAttention",
  progressOverview = "progressOverview"
}

export type StepConfig = Step.StepOptions & {
  action?: string;
  image?: string;
};

export enum OnboardingGALabels {
  step = "Step Onboarding"
}
